module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "dragover"
    },
    on: {
      "dragover": _vm.dragover,
      "drop": _vm.drop
    }
  }, [_c('h3', [_vm._v("Drag & drop your file here")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("accepts images and PDFs")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "file",
      "name": "file"
    },
    on: {
      "change": _vm.selected
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("or "), _c('label', {
    attrs: {
      "for": "file"
    }
  }, [_vm._v("click to browse")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0043a522"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Uploader.vue
// module id = 89
// module chunks = 2